import { useEffect, useState } from "react";
export const breakpoints = {
    mobile: "(max-width: 767px)",
    tablet: "(min-width: 768px) and (max-width: 1279px)",
    desktop: "(min-width: 1280px)",
};
const getBreakpoint = (breakpoints) => {
    return Object.keys(breakpoints).find((breakpoint) => window.matchMedia(breakpoints[breakpoint]).matches);
};
export const useDeviceBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState("desktop");
    useEffect(() => {
        const handleResize = () => {
            setBreakpoint(getBreakpoint(breakpoints));
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        breakpoint,
    };
};
//# sourceMappingURL=useDeviceBreakpoint.js.map